import axios from './axiosSettings';
import { getServiceName } from './serviceName';

let controller;

const isUrlChanged = (requestUrl, requestParams, responseUrl) => {
    const filteredParams = Object.keys(requestParams).reduce(
        (acc, key) => (requestParams[key] ? { ...acc, [key]: requestParams[key] } : acc),
        {}
    );

    const requestUrlSearchParams = new URLSearchParams(filteredParams);
    const parsedRequestUrl = new URL(`${requestUrl}?${requestUrlSearchParams.toString()}`, window.location.origin);
    parsedRequestUrl.searchParams.sort();
    const parsedResponseUrl = new URL(responseUrl);
    parsedResponseUrl.searchParams.sort();

    return parsedRequestUrl.href !== parsedResponseUrl.href;
};

export default {
    ...axios,

    getPage(url, config = { params: {} }, catchRedirect = false) {
        controller?.abort?.();

        controller = new AbortController();
        config.signal = controller.signal;
        const serviceName = getServiceName();

        config.headers = config.headers || {};
        config.params.disableBrowserCache = true;
        config.headers['X-Static-Version'] = window.globalServiceVars[serviceName].build;

        return axios
            .get(url, config)
            .then((response) => {
                if (
                    catchRedirect &&
                    isUrlChanged(response.config.url, response.config.params, response.request.responseURL)
                ) {
                    throw new Error('request_redirected');
                }

                return response.data;
            })
            .then(
                (data) => {
                    return data;
                },
                (reason) => {
                    return Promise.reject(reason);
                }
            );
    },
};
